<template>
  <div class="filter-select">
    <div class="filter-select__value" @click.stop="onOpen">
      <template v-if="selectedValues.length">
        <RouterLink
          v-for="key in selectedValues"
          :key="key"
          :to="getRemoveFilterLink(key)"
          class="filter-select__value-item"
        >
          {{ options[key] }}
        </RouterLink>
      </template>

      <span v-else class="filter-select__placeholder">{{ placeholder }}</span>
      <Icon id="chevron" :class="['filter-select__icon', { '-open': isTrayOpen }]" />
    </div>

    <DropDown
      :is-open="isTrayOpen"
      class="filter-select__tray"
      content-class="filter-select__tray-content"
    >
      <RouterLink
        v-for="key in unselectedValues"
        :key="key"
        :to="getAddFilterLink(key)"
        class="filter-select__tray-item"
      >
        {{ options[key] }}
      </RouterLink>
    </DropDown>
  </div>
</template>

<script>
import DropDown from '@/components/global/DropDown.vue'
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'FilterSelect',
  components: { DropDown, Icon },
  props: {
    param: { type: String, required: true },
    multiple: { type: Boolean, default: false },
    options: { type: Object, default: Object },
    placeholder: { type: String, default: null },
  },
  data() {
    return {
      isTrayOpen: false,
    }
  },
  computed: {
    selectedValues() {
      const queryValues = this.$route.query[this.param] || ''
      return queryValues.split(',').filter((str) => str.length)
    },
    unselectedValues() {
      return Object.keys(this.options).filter((key) => this.selectedValues.indexOf(key) < 0)
    },
  },
  beforeUnmount() {
    this.removeBodyEventListener()
  },
  methods: {
    getRemoveFilterLink() {
      const { query, ...currentRoute } = this.$route
      return currentRoute
    },
    getAddFilterLink(filterKey) {
      const { query, ...currentRoute } = this.$route
      return { ...currentRoute, hash: '#map', query: { [this.param]: filterKey } }
    },
    removeBodyEventListener() {
      document.body.removeEventListener('click', this.onClose)
    },
    onClose() {
      this.removeBodyEventListener()
      this.isTrayOpen = false
    },
    onOpen() {
      document.body.addEventListener('click', this.onClose)
      this.isTrayOpen = !this.isTrayOpen
    },
  },
}
</script>
